import React from "react";
import { motion } from "framer-motion";
import { Heart, UserCheck, Plane, Home, Users, Sparkles, FileCheck, Wallet } from "lucide-react";

const COMMITMENTS = [
    { icon: UserCheck, title: "1 Counselor Khusus", desc: "Satu siswa didampingi secara personal dari awal sampai proses aplikasi." },
    { icon: Sparkles, title: "Pemetaan Jurusan & Kampus", desc: "Kami bantu pilih jurusan, negara, dan kampus berdasarkan profil serta tujuan masa depan." },
    { icon: Wallet, title: "Simulasi Biaya & ROI", desc: "Agar keluarga memahami estimasi biaya dan potensi return sebelum mengambil keputusan." },
    { icon: FileCheck, title: "Cek Dokumen Awal", desc: "Transkrip, IELTS/TOEFL, CV, dan dokumen pendukung dicek lebih awal agar tidak terlambat." },
    { icon: Plane, title: "Pendampingan Aplikasi & Visa", desc: "Dari dokumen, submission, interview, sampai visa preparation." },
    { icon: Users, title: "Grup Khusus Orang Tua", desc: "Orang tua bisa ikut memantau perjalanan anak dengan lebih tenang." },
];

export default function PhilosophySection() {
    return (
        <section className="bg-white py-20 md:py-28 relative overflow-hidden" data-testid="philosophy-section">
            <div className="absolute -top-32 -right-32 w-96 h-96 bg-[#F5A623]/8 rounded-full blur-3xl pointer-events-none" />
            <div className="absolute -bottom-32 -left-32 w-96 h-96 bg-[#0A1A2F]/5 rounded-full blur-3xl pointer-events-none" />
            <div className="max-w-7xl mx-auto px-6 md:px-12 relative">
                <div className="grid lg:grid-cols-12 gap-12 lg:gap-16">
                    <div className="lg:col-span-5">
                        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}>
                            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#F5A623]/15 text-[#0A1A2F] text-xs font-semibold mb-5 border border-[#F5A623]/30">
                                <Heart className="w-3.5 h-3.5 text-[#F5A623]" />
                                FILOSOFI GANTARI MENEMANIMU
                            </div>
                            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0A1A2F] leading-tight tracking-tight">
                                Kamu Bukan Sekadar{" "}
                                <span className="relative inline-block">
                                    <span className="relative z-10">Nilai, IPK,</span>
                                    <span className="absolute bottom-1 left-0 right-0 h-2.5 bg-[#F5A623]/40 -z-0 rounded" />
                                </span>{" "}
                                atau Berkas Dokumen.
                            </h2>
                            <p className="mt-6 text-base sm:text-lg text-slate-600 leading-relaxed">
                                Kuliah ke luar negeri adalah keputusan besar untuk masa depan anak dan keluarga. Karena itu, Gantari Edu tidak hanya mencarikan kampus populer, tapi membantu memilih{" "}
                                <strong className="text-[#0A1A2F]">jalur yang paling masuk akal</strong> berdasarkan profil akademik, kemampuan finansial, tujuan karier, dan kesiapan dokumen.
                            </p>
                            <p className="mt-4 text-base text-slate-600 leading-relaxed italic border-l-4 border-[#F5A623] pl-4">
                                "Teknologi membantu mempercepat. Counselor membantu memastikan langkahmu tepat."
                            </p>
                        </motion.div>
                    </div>
                    <div className="lg:col-span-7">
                        <div className="grid sm:grid-cols-2 gap-4">
                            {COMMITMENTS.map((c, i) => {
                                const Icon = c.icon;
                                return (
                                    <motion.div
                                        key={c.title}
                                        initial={{ opacity: 0, y: 24 }}
                                        whileInView={{ opacity: 1, y: 0 }}
                                        viewport={{ once: true, margin: "-50px" }}
                                        transition={{ duration: 0.5, delay: i * 0.07 }}
                                        className="bg-white border border-slate-200 rounded-2xl p-6 hover:border-[#F5A623] hover:shadow-lg hover:shadow-[#F5A623]/10 transition-all"
                                        data-testid={`commitment-${i}`}
                                    >
                                        <div className="w-11 h-11 rounded-xl bg-[#0A1A2F] flex items-center justify-center mb-4">
                                            <Icon className="w-5 h-5 text-[#F5A623]" />
                                        </div>
                                        <h3 className="font-display font-semibold text-lg text-[#0A1A2F] leading-snug">{c.title}</h3>
                                        <p className="mt-2 text-sm text-slate-600 leading-relaxed">{c.desc}</p>
                                    </motion.div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
